import React from 'react';
import PropTypes from 'prop-types';

import { Cover, FAQs, Layout, SectionRealResults, SectionTextMediaWrap, MdTextMedia, SEO } from 'components';
import { media } from "utils/media";

import contentSEO from "cms/content/teeth-whitening-upgrade-seo.yml";
import contentCover from "cms/content/teeth-whitening-upgrade-cover.yml";
import contentSecOne from "cms/content/teeth-whitening-upgrade-one.yml";
import contentSecTwo from "cms/content/teeth-whitening-upgrade-two.yml";
import contentFaqs from "cms/content/teeth-whitening-upgrade-faqs.yml"
import contentUsa from "cms/content/teeth-whitening-upgrade-usa.yml"
import contentKit from "cms/content/teeth-whitening-upgrade-kit.yml"

const TeethWhiteningPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale} className='teeth-whitening-wrapper'>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Cover
      title={contentCover.title}
      text={contentCover.text}
      image={{ url: media(contentCover.image), alt: 'Woman pouring a transparent paste into her teeth mould' }}
      overlap={contentCover.overlap}
      stamp={contentCover.stamp}
      trustpilot={contentCover.trustpilot}
      button={{ path: contentCover.buttonUrl, label: contentCover.buttonText, external: false, newTab: false }}
      className='cover-whitening'
    />

    <MdTextMedia 
      enabled={true}
      textUk={contentUsa.textUk}
      textSe={contentUsa.textSe}
      textEn={contentUsa.textEn}
      text={contentUsa.text}
      image={{ url: media(contentUsa.image) , alt: "KöR Whitening Kit with 50% discount" }}
      locale={locale}
      reverse={true}
    />

    <SectionTextMediaWrap content={contentSecOne} locale={locale}/>

    <SectionRealResults />

    <MdTextMedia 
      enabled={true}
      textUk={contentKit.textUk}
      textSe={contentKit.textSe}
      textEn={contentKit.textEn}
      image={{ url: media(contentKit.image) , alt: "Straighten and Whiten kit" }}
      locale={locale}
      reverse={true}
      badges={contentKit.badges}
      badgeOne={contentKit.badgeOne}
      badgeTwo={contentKit.badgeTwo}
    />

    <SectionTextMediaWrap content={contentSecTwo} locale={locale}/>

    {contentFaqs.enabled && <FAQs title='FAQs' faqsData={contentFaqs['faqs']} className='mb-90' locale={locale} />}
  </Layout>
);

TeethWhiteningPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default TeethWhiteningPage;
